import { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
export const NavBar = () => {
  const [activelink, setActivelink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const onUpdateActiveLink = (value) => {
    setActivelink(value);
  };
  return (
    <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="#home">
          <img src={logo} alt="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />{" "}
        <Navbar.Toggle>
          <span className="navbar-toggle-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              href="#home"
              className={`navbar-link ${activelink === "home" ? "active" : ""}`}
              onClick={() => onUpdateActiveLink("home")}
            >
              Home
            </Nav.Link>
            <Nav.Link
              href="#skills"
              className={`navbar-link ${activelink === "skills" ? "active" : ""}`}
              onClick={() => onUpdateActiveLink("skills")}
            >
              skills
            </Nav.Link>
            <Nav.Link
              href="#projects"
              className={`navbar-link ${activelink === "projects" ? "active" : ""}`}
              onClick={() => onUpdateActiveLink("projects")}
            >
              Projects
            </Nav.Link>
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a target="_blank" href="https://github.com/diaa-codes">
                <img src={navIcon2} alt="github" />
              </a>
              <a
                target="_blank"
                href="https://www.linkedin.com/in/diaa-eldin-samy-8aa0bb3a5/"
              >
                <img src={navIcon1} alt="linkedin" />
              </a>
              <a target="_blank" href="https://www.behance.net/diaamohammad">
                <img src={navIcon3} alt="behance" />
              </a>
            </div>
            <button onClick={() => console.log("connect")}>
              <span>let's connect</span>{" "}
            </button>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
